import React from 'react';
const CourierService = () => <div className="service-page"><h1>Courier Service</h1><p>Fast and secure courier services for your parcels.</p></div>;
export default CourierService;
